import { Navbar } from "@/components/okaia/Navbar";
import { Hero } from "@/components/okaia/Hero";
import { SloganMarquee } from "@/components/okaia/Marquee";
import { MetamorphoseFrise } from "@/components/okaia/MetamorphoseFrise";
import { Profiles } from "@/components/okaia/Profiles";
import { Editorial } from "@/components/okaia/Editorial";
import { Benefits } from "@/components/okaia/Benefits";
import { Steps } from "@/components/okaia/Steps";
import { DiagnosticExample } from "@/components/okaia/DiagnosticExample";
import { Founder } from "@/components/okaia/Founder";
import { Testimonials } from "@/components/okaia/Testimonials";
import { Orientation } from "@/components/okaia/Orientation";
import { Trust } from "@/components/okaia/Trust";
import { FinalCTA } from "@/components/okaia/FinalCTA";
import { Footer } from "@/components/okaia/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="relative">
      <Navbar />
      <Hero />
      <SloganMarquee />
      <MetamorphoseFrise />
      <Profiles />
      <Editorial />
      <Benefits />
      <Steps />
      <DiagnosticExample />
      <Founder />
      <Testimonials />
      <Trust />
      <Orientation />
      <FinalCTA />
      <Footer />
    </main>
  );
}
